import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Custom Exports',
		url: '/custom_exports',
		icon: 'archive',
	},
];

export default class Custom_Exports extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Objects.Custom_Export_2669
					location={location}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

			</div>
		)
	}
};



